<h1 mat-dialog-title>Confirm Removal</h1>
<div mat-dialog-content>
  <p>Are you sure you want to remove {{user.email}}?</p>
</div>
<div mat-dialog-actions style="display: flex; align-content:center; justify-content:center;">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial>No</button>
  <button mat-raised-button color="warn" (click)="onYesClick()">Yes</button>
</div>
